import { render } from "./LoadingSpinner.vue?vue&type=template&id=90f23f56&scoped=true"
const script = {}

import "./LoadingSpinner.vue?vue&type=style&index=0&id=90f23f56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90f23f56"]])

export default __exports__